import React from 'react';

const CountryMap = React.forwardRef(({ countryCode, className = '', ...props }, ref) => {
  if (!countryCode) {
    return null;
  }

  if (typeof countryCode !== 'string' || countryCode.length !== 3) {
    console.warn(`CountryMap: Invalid countryCode provided: ${countryCode}`);
    return null;
  }

  const svgPath = `${process.env.PUBLIC_URL}/images/country-svgs/${countryCode.toLowerCase()}.svg`;

  const handleLoadError = () => {
    console.warn(`Failed to load country map SVG. Path: ${svgPath}`);
  };

  return (
    <img 
      ref={ref}
      src={svgPath} 
      alt={`${countryCode} map`} 
      className={`map-silhouette-icon ${className}`}
      onError={handleLoadError}
      {...props}
    />
  );
});

CountryMap.displayName = 'CountryMap';

export default CountryMap;